import React, { useContext, useState } from "react";
import StarekContext from "../context/StarekContext";
import SearchModal from "./Search/SearchModal";
import InfiniteScroll from "react-infinite-scroll-component";
import { gql, useQuery, useMutation } from "@apollo/client";

function Header(props) {
    const GET_USER_ACTIVITIES_QUERY = gql`
        query User($where: UserWhereUniqueInput!) {
            user(where: $where) {
                id
                name
                email
                home_timezone
                show_time_in_home_timezone
                username
                verified
                memberships {
                    role {
                        name
                    }
                }
            }
        }
    `;
    const starekContext = useContext(StarekContext);

    const {
        data: userData,
        loading: userLoading,
        error: userError,
    } = useQuery(GET_USER_ACTIVITIES_QUERY, {
        variables: {
            where: { id: parseInt(starekContext?.user?.id) },
        },
    });

    const [selected, setSelected] = useState(false);
    const [item, setItem] = useState();
    const [timeZones, setTimeZones] = useState();
    const [showModal, setShowModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activities, setActivities] = useState([]);
    const [totalActivity, setTotalActivity] = useState(0);
    const [types, setTypes] = useState([]);
    const [noMore, setNoMore] = useState(true);
    const [page, setPage] = useState(2);

    const handleKeyup = (e) => {
        const code = e.which;
        if (code === 13) openSearch();
    };

    const toggleSearchModal = (value) => setShowModal(value);

    const openSearch = () => setShowModal(true);

    const fetchData = async () => {
        /** TODO: use gql query here */
    };
    return (
        <>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <span
                            className="nav-link"
                            data-widget="pushmenu"
                            role="button"
                        >
                            <i className="fas fa-bars" />
                        </span>
                    </li>

                    <li className="nav-item d-none d-sm-inline-block">
                        <span className="nav-link">{userData?.user?.name}</span>
                    </li>
                    {userData?.user?.email && (
                        <li className="nav-item d-none d-sm-inline-block">
                            <span className="nav-link">
                                {`(${userData?.user?.email})`}
                            </span>
                        </li>
                    )}
                    {userLoading && (
                        <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    )}
                </ul>

                <ul className="navbar-nav ml-auto">
                    {/* Navbar Search */}
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            data-widget="navbar-search"
                            href="#"
                            role="button"
                        >
                            <i className="fas fa-search" />
                        </a>
                        <div className="navbar-search-block">
                            <div className="input-group input-group-sm">
                                <input
                                    className="form-control form-control-navbar"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                    onKeyUp={handleKeyup}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-navbar"
                                        onClick={openSearch}
                                    >
                                        <i className="fas fa-search" />
                                    </button>
                                    <button
                                        className="btn btn-navbar"
                                        type="button"
                                        data-widget="navbar-search"
                                    >
                                        <i className="fas fa-times" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                    {/* Notifications Dropdown Menu */}
                    <li className="nav-item dropdown">
                        <a className="nav-link" data-toggle="dropdown" href="#">
                            <i className="far fa-bell" />
                            <span className="badge badge-warning navbar-badge">
                                {totalActivity}
                            </span>
                        </a>

                        <div
                            className="dropdown-menu dropdown-menu-lg dropdown-menu-right"
                            style={{
                                maxWidth: "500px",
                            }}
                        >
                            <span className="dropdown-item dropdown-header">
                                {totalActivity} Notifications
                            </span>

                            <InfiniteScroll
                                dataLength={activities.length} //This is important field to render the next data
                                next={fetchData}
                                hasMore={noMore}
                                endMessage={
                                    <p style={{ textAlign: "center" }}>
                                        <b>You have seen all activities.</b>
                                    </p>
                                }
                                height={400}
                            >
                                {activities &&
                                    activities.map((item) => {
                                        let obj = types.filter(
                                            (a) => a.id == item.entity_type_id
                                        );
                                        let itemData = JSON.parse(
                                            item.parameters
                                        );
                                        return (
                                            <>
                                                <div
                                                    className="dropdown-divider"
                                                    key={item.id}
                                                />
                                                <span className="dropdown-item">
                                                    {obj[0] && obj[0].code}{" "}
                                                    <a
                                                        href={
                                                            "../" +
                                                            (obj[0] &&
                                                                obj[0].plural) +
                                                            "/" +
                                                            itemData.id
                                                        }
                                                    >
                                                        {itemData.name}
                                                    </a>
                                                    {item.action_type == 1
                                                        ? " Executed "
                                                        : item.action_type == 2
                                                        ? " Added "
                                                        : item.action_type == 4
                                                        ? " Updated "
                                                        : item.action_type == 8
                                                        ? " Deleted "
                                                        : ""}
                                                    <span className="float-right text-muted text-sm">
                                                        {new Date(
                                                            item.action_type ==
                                                            4
                                                                ? item.updated_at
                                                                : item.created_at
                                                        ).toDateString()}
                                                    </span>
                                                </span>
                                            </>
                                        );
                                    })}
                            </InfiniteScroll>
                        </div>
                    </li>

                    <li className="nav-item">
                        <span
                            className="nav-link"
                            data-widget="control-sidebar"
                            data-slide="true"
                            role="button"
                            onClick={async () => {
                                await starekContext.logout();
                            }}
                        >
                            <i className="fa fa-power-off" />
                        </span>
                    </li>
                    <li className="nav-item">
                        <span
                            className="nav-link"
                            data-widget="fullscreen"
                            href="#"
                            role="button"
                        >
                            <i className="fas fa-expand-arrows-alt" />
                        </span>
                    </li>
                </ul>
            </nav>
            {selected && (
                <div
                    role="dialog"
                    aria-modal="true"
                    className="fade modal show"
                    tabIndex={-1}
                    style={{ display: "block" }}
                >
                    <div
                        className="modal-dialog-centered"
                        style={{ width: "50%", margin: "auto" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title h4">
                                    <h3>User Profile</h3>
                                </div>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                        setSelected(false);
                                    }}
                                >
                                    <i className="fa fa-times nav-icon"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <section className="content">
                                    <div className="form-group">
                                        <label>Home Time Zone</label>
                                        <select
                                            className="form-control"
                                            id="homeTimeZoneId"
                                            name="homeTimeZoneId"
                                            value={
                                                item.home_timezone
                                                    ? item.home_timezone
                                                    : ""
                                            }
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    home_timezone:
                                                        e.target.value,
                                                });
                                            }}
                                        >
                                            <option value="0">
                                                --Select--
                                            </option>
                                            {timeZones.map((s, i) => (
                                                <option key={i} value={s}>
                                                    {s}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Always Use Home Timezone</label>
                                        <input
                                            type="checkbox"
                                            className="ml-3"
                                            id="show_time_in_home_timezone"
                                            name="show_time_in_home_timezone"
                                            checked={
                                                item.show_time_in_home_timezone
                                            }
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    show_time_in_home_timezone:
                                                        !item.show_time_in_home_timezone,
                                                });
                                            }}
                                        ></input>
                                        <br />
                                        <small>
                                            checking this box will override
                                            browser time zone - not recommended
                                        </small>
                                    </div>
                                </section>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-sm btn-info btn-primary pull-left"
                                    onClick={async () => {
                                        /** TODO; use gql query here */
                                    }}
                                >
                                    Update
                                </button>{" "}
                                <button
                                    className="btn btn-sm btn-info pull-left"
                                    onClick={() => {
                                        setSelected(false);
                                    }}
                                >
                                    Close
                                </button>{" "}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModal && (
                <SearchModal
                    visibility={showModal}
                    initialSearchText={searchText}
                    setVisibility={toggleSearchModal}
                    setInitialSearchText={setSearchText}
                />
            )}
        </>
    );
}

export default Header;
